var Core = require('f.component.video.pc');

var utils = require('f.component.util.pc');

var imageList = require('../image');

var tabline = require('../tabline');

var tmpl = require('./main.ejs');

var Events = require('f.core.event');

var defaultConf = {
    swfUrl: '//vxml.ifengimg.com/swf/zuhe/zuhePlayer_v1.0.48.swf',
    containerId: '',
    width: 600,
    height: 455,
};

var defaultParamConf = {
    allowFullScreen: 'true',
    wmode: 'transparent',
    allowScriptAccess: 'always',
};

var defaultVarConf = {
    guid: '',
    from: utils.getFrom(),
    AutoPlay: true,
    ADPlay: true,
    uid: utils.getCookie('userid'),
    sid: utils.getCookie('sid'),
    locid: utils.getCookie('ilocid'),
    startTime: utils.getStarTime(),
    parent: 0,
    adType: 1,
    preAdType: 0,
    pageurl: window.location.href,
    PlayerName: 'VZHPlayer',
    danmu: true,
    subject: ''
};

function formatOptions(videoData) {
    var optionsData = {
        conf: utils.containParams(defaultConf, videoData),
        varConf: utils.containParams(defaultVarConf, videoData),
        paramConf: utils.containParams(defaultParamConf, videoData),
        pauseCallback: function() {
            alert('pause');
        },
        autoPlay: true,
        listId: videoData.listId,
    };

    return optionsData;
}

var Video = function(options, isList) {
    this.init(options, isList);
};

var currentVideo = null;
Video.current = null;

Video.prototype = {
    init: function(options) {
        //console.log(options);
        this.videoOptions = [];
        this.videoList = [];
        this.list = options.list;
        for (var i = 0; i < options.list.length; i++) {
            this.list[i].guid = this.list[i].liveVideoId;
            this.list[i].width = options.livewidth;
            this.list[i].height = options.liveheight;
            this.list[i].poster =
                this.list[i].poster || '//y0.ifengimg.com/ffeefe4ba8f67e3e/2015/2/livepic-nobtn.png';
            this.list[i].swfUrl = '//p0.ifengimg.com/a/2018/0810/2/vZHPlayer_v7.0.4.swf';// '//vxml.ifengimg.com/swf/vZHPlayer_v7.0.3.swf'; //"//vxml.ifengimg.com/swf/freeVPlayer_v1.0.0.swf";//this.list[i].flashUrl || "";
            this.list[i].autoPlay = true;
            this.list[i].listId = i;
            ////console.log(formatOptions(this.list[i]));
            this.videoOptions.push(formatOptions(this.list[i]));
        }

        this.el = $(tmpl());
        //this.danmuBox = this.el.find('.danmubox');
        this.initDom(options);
        //console.log(this.videoOptions);
        currentVideo = new Core(this.videoOptions[0], false);
        currentVideo.renderTo($(this.el).find('.c-video__embed'));
        this.videoList.push(currentVideo);
        Video.current = currentVideo;
        this.Core = currentVideo;
        this.changeLine();
    },
    initDom: function() {
        var tablineHtml = new tabline({ list: this.list });
        tablineHtml.renderTo(this.el);
        //console.log(this.el);
        this.ownerNode = $(this.el).children()[0];
    },

    changeLine: function() {
        var _self = this;
        this.el.on('click', '[data-lineid]', function() {
            var lineid = $(this).data('lineid');
            // console.log(lineid);
            if (!$(this).hasClass('clicked')) {
                return false;
            } else {
                if (Video.current != null) {
                    currentVideo.hide();
                    currentVideo = null;
                }
                if (typeof _self.videoList[lineid] === 'undefined') {
                    currentVideo = new Core(_self.videoOptions[lineid], false);
                    currentVideo.renderTo(_self.el.find('.c-video__embed'));
                    _self.videoList[lineid] = currentVideo;
                } else {
                    currentVideo = _self.videoList[lineid];
                    currentVideo.show();
                }

                Video.current = currentVideo;
                _self.trigger('change', lineid);
            }
        });
    },

    changgeDanmu: function(isdanmu) {
        this.videoOptions.list.map(function(item) {
            item.danmu = isdanmu;
        });
    },

    showBack: function(content) {
        this.Core.danmuSend(content);
    },

    renderTo: function(parentNode) {
        parentNode.append(this.el);
    },
};

Events.mixTo(Video);
module.exports = Video;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videohead.pc/app/modules/video/playback.js